export const getDayMinutes = (date: Date) => {
  return date.getHours() * 60 + date.getMinutes();
};

export const getFirstDayTimeSlot = (date: Date, timeSlots: number[]) => {
  const dayMinutes = getDayMinutes(date);
  return timeSlots.find((minutes) => minutes >= dayMinutes);
};
